import React from "react";
import Navbar from "../components/landing/Navbar";
import Footer from "../components/landing/Footer";
import SEOHead from "../components/SEOHead";
import { FaqList } from "../components/landing/FAQ";
import { faqJsonLd } from "../lib/faq";

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-cream-50 text-moss-900" data-testid="faq-page">
      <SEOHead
        path="/faq"
        title="Frequently asked questions | Binshare"
        description="Answers to common questions about Binshare: how it works, what it costs, carrier registration, receipts, Reuse listings, carrier fees, payouts and where Binshare is available."
        jsonLd={faqJsonLd}
      />
      <Navbar />
      <main className="pt-28 md:pt-36 pb-24">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
            FAQ
          </p>
          <h1
            className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-moss-950 leading-[1.05] text-balance"
            data-testid="faq-page-heading"
          >
            Frequently asked questions
          </h1>
          <p className="mt-5 text-base md:text-lg text-moss-700 leading-relaxed max-w-2xl">
            Can&apos;t find what you need? Email{" "}
            <a
              href="mailto:support@binshare.co.uk"
              className="font-semibold text-moss-900 underline underline-offset-2 hover:text-sage-700"
              data-testid="faq-page-support-email"
            >
              support@binshare.co.uk
            </a>
            .
          </p>
          <div className="mt-12">
            <FaqList testidPrefix="faq-page" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
